import React from 'react';
import logoMark from '../../res/images/logo-mark.svg';

// The ring + pulse animation lives in public/index.html, keyed off #loaderIn,
// so this spinner and the boot loader shown before React mounts look identical.
const Spinner = () => {
    return (
        <div style={{ height: '100vh', backgroundColor: 'white', display: 'flex', width: 'auto', justifyContent: "center", alignItems: 'center', borderRadius: 8 }}>
            <div id="loaderIn" role="status" aria-label="Loading">
                <img className="loaderMark" src={logoMark} alt='' />
            </div>
        </div>
    );
};

export default Spinner;
